import PropTypes from 'prop-types';

const MessageBar = ({ msg, type = 'error', testid = '' }) => {
  let css = 'errorMsg';
  if (type === 'success') css = 'successMsg';
  else if (type === 'normal') css = '';

  return (
    <>
      <span className={css} data-cy={testid}>
        {msg}
      </span>
    </>
  );
};

MessageBar.propTypes = {
  msg: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['error', 'success', 'normal']),
};

export default MessageBar;
